import { render, staticRenderFns } from "./CustomerButtons.vue?vue&type=template&id=c10b5962&lang=html"
import script from "./CustomerButtons.vue?vue&type=script&lang=js"
export * from "./CustomerButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports